module.exports = __webpack_public_path__ + "img/checked-radio.8c41a2eb.svg";